// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__Z8jmq","rootCenter":"LoadMoreObserver_rootCenter__OgMA5","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1v-mb"};